import { render, staticRenderFns } from "./SuppliersTableRow.vue?vue&type=template&id=56ff14a2&scoped=true&lang=pug"
import script from "./SuppliersTableRow.vue?vue&type=script&lang=js"
export * from "./SuppliersTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ff14a2",
  null
  
)

export default component.exports